import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=687fadf7&scoped=true&"
import script from "./Specifications.vue?vue&type=script&lang=js&"
export * from "./Specifications.vue?vue&type=script&lang=js&"
import style0 from "./Specifications.vue?vue&type=style&index=0&id=687fadf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fadf7",
  null
  
)

export default component.exports